<template>
  <yxt-drawer
    :visible.sync="drawerVisible"
    append-to-body
    size="960px"
    :class="{pr0: step === 1}"
    class="talent-create-eval-drawer yxtbiz-eval-create-drawer"
  >
    <eval-step
      :canPublish="canPublish"
      :stepsData="stepsData"
      :step.sync="step"
      :sourceType="sourceType"
    />
    <!-- 二三级评估 -->
    <multi-main
      v-if="parentId"
      v-bind="$attrs"
      :id.sync="evalId"
      :parent-id="parentId"
      :prev-id="prevId"
      :bind-map="bindMap"
      :get-users="getUsers"
      :data-permission-code="dataPermissionCode"
      :evaluator-data-permission="evaluatorDataPermission"
      :function-code="functionCode"
      :source-type="sourceType"
      class="pt56"
      :step="step"
      @next="next"
      @prev="prev"
      @save="save"
    />
    <div v-else class="pt56">
      <!-- 选择工具 -->
      <select-util
        v-if="stepsData[step - 1] === 'select'"
        :purposeId="purposeId"
        :id.sync="evalId"
        :model-id="modelId"
        :before-id="beforeId"
        v-bind="$attrs"
        @next="next"
        @changeAssess="changeAssess"
        :survey-id.sync="surveyId"
        @cancel="drawerVisible = false"
        :scene.sync="selectScene"
        :type.sync="type"
        :sourceType="sourceType"
        :isQueCreateHidden="isQueCreateHidden"
        :is-after-test="isAfterTest"
      />
      <!-- 方案信息 -->
      <info
        v-show="stepsData[step - 1] === 'info'"
        :show-info="stepsData[step - 1] === 'info'"
        :purposeId="purposeId"
        :id.sync="evalId"
        :model-id="modelId"
        :skill-model-id="modelId"
        ref="info"
        v-bind="$attrs"
        @next="next"
        @prev="prev"
        :steps-data="stepsData"
        :scene.sync="selectScene"
        :survey-id.sync="surveyId"
        :bindMap="bindMap"
        :sourceType="sourceType"
        :type="type"
        :functionCode="functionCode"
        :dataPermissionCode="userDataPermissionCode"
        :owners="owners"
        :before-id="beforeId"
        :is-after-test.sync="isAfterTest"
        @changeAssess="changeAssess"
      />
      <!-- 被评估人，评估关系 -->
      <relations
        v-if="stepsData[step - 1] === 'add'"
        :id="evalId"
        :purposeId="purposeId"
        v-bind="$attrs"
        @next="next"
        @prev="prev"
        :fnValidMembers="fnValidMembers"
        :dataPermissionCode="dataPermissionCode"
        :evaluatorDataPermission="evaluatorDataPermission"
        :functionCode="functionCode"
        :getUsers="getUsers"
        :sourceType="sourceType"
        :scene="selectScene"
        :type="type"
        :projectId="projectId"
      />
      <!-- 发布评估 -->
      <publish
        v-if="stepsData[step - 1] === 'publish'"
        :can-publish="canPublish"
        :can-save="canSave"
        :id="evalId"
        v-bind="$attrs"
        :purposeId="purposeId"
        @next="next"
        @prev="prev"
        @publish="publish"
        @save="save"
        :sourceType="sourceType"
      />
    </div>
  </yxt-drawer>
</template>

<script>;
import { SOURCE_TYPE } from './config';
import EvalStep from './components/eval-step';
import SelectUtil from './select-util';
import Info from './info.vue';
import Relations from './relations';
import Publish from './publish';
import MultiMain from './multi/main.vue';

export default {
  name: 'YxtbizEvalCreateDrawer',
  name_zh: '创建测评组件',
  eventList: [{
    type: 'publish',
    handler: 'publish',
    label: '组件发布成功后的回调'
  }, {
    type: 'save',
    handler: 'save',
    label: '组件保存成功后的回调'
  }],
  components: {
    EvalStep,
    SelectUtil,
    Info,
    Relations,
    Publish,
    MultiMain
  },
  props: {
    canPublish: {
      type: Boolean,
      default: false,
      desc: '是否支持发布',
      setter: 'BooleanSetter'
    },
    canSave: {
      type: Boolean,
      default: true,
      desc: '是否支持保存',
      setter: 'BooleanSetter'
    },
    isMultigang: {
      type: Boolean,
      default: false,
      desc: '是否多岗位',
      setter: 'BooleanSetter'
    },
    hasAddPerson: {
      type: Boolean,
      default: false,
      desc: '是否有添加人员步骤',
      setter: 'BooleanSetter'
    },
    // 来源类型（0-测评；1-测训一体化；2：盘点 4:岗位地图 5:层级地图)
    sourceType: {
      type: Number,
      default: 0,
      desc: '来源类型',
      setter: 'SelectSetter',
      enums: [{
        label: '测评',
        value: 0
      }, {
        label: '测训一体化',
        value: 1
      }, {
        label: '人才盘点安排',
        value: 2
      }, {
        label: '岗位地图安排',
        value: 4
      }, {
        label: '层级地图安排',
        value: 5
      }]
    },
    visible: {
      type: Boolean,
      desc: '组件的显隐',
      setter: 'BooleanSetter'
    },
    parentId: {
      type: String,
      default: '',
      desc: '多次行为评估下，上一次评估id',
      setter: 'StringSetter'
    },
    prevId: {
      type: String,
      default: '',
      desc: '多次行为评估下，是否采用上一次的评估设置的id',
      setter: 'StringSetter'
    },
    id: {
      type: String,
      default: '',
      desc: '编辑模式下的测评id',
      setter: 'StringSetter'
    },
    modelId: {
      type: String,
      default: '',
      desc: '模型的ID',
      setter: 'StringSetter'
    },
    purposeId: {
      type: String,
      default: '1,2,3',
      desc: '场景:人才盘点-1 竞聘选拔-2 培养发展-3,多个时使用英文的逗号隔开',
      setter: 'StringSetter'
    },
    // 评估方案场景(1-胜任力 2-人格 3-通用)
    scene: {
      type: Number,
      default: 1,
      desc: '评估方案场景',
      setter: 'TabSetter',
      enums: [{
        label: '胜任力',
        value: 1
      }, {
        label: '人格',
        value: 2
      }, {
        label: '通用',
        value: 3
      }]
    },
    eType: {
      type: [Number, String],
      default: 2,
      desc: '测评模式',
      setter: 'TabSetter',
      enums: [{
        label: '选择工具',
        value: 1
      }, {
        label: '行为评估',
        value: 2
      }]
    },
    dataPermissionCode: {
      type: String,
      default: 'gwdt_addassessor_extent', /* 岗位地图-测评管理-人员管理选人 */
      desc: '岗位地图-测评管理-人员管理选人数据权限',
      setter: 'StringSetter'
    },
    userDataPermissionCode: { // 选择负责人的数据权限
      type: String,
      default: '',
      desc: '选择负责人的数据权限',
      setter: 'StringSetter'
    },
    functionCode: {
      type: String,
      default: '',
      desc: '导航权限',
      setter: 'StringSetter'
    },
    evaluatorDataPermission: {
      type: String,
      default: 'gwdt_eval_tools_addassessor_extent', /* 选评估人 */
      desc: '选评估人的数据权限',
      setter: 'StringSetter'
    },
    // 默认选中step值
    defaultStep: {
      type: Number,
      default: 1,
      desc: '默认选择第几步(根据是否有添加人员步骤进行删减)',
      setter: 'TabSetter',
      enums: [{
        label: '第一步',
        value: 1
      }, {
        label: '第二步',
        value: 2
      }, {
        label: '第三步',
        value: 3
      }, {
        label: '第四步',
        value: 3
      }]
    },
    // 选人方法
    getUsers: {
      type: Function,
      default: () => {},
      desc: '加人时列表展示的人员数据，从此方法获取',
      setter: 'FunctionSetter'
    },
    fnValidMembers: {
      type: Function,
      default: () => {
        return new Promise((resolve, reject) => {
          resolve(true);
        });
      },
      desc: '添加人员时，点击下一步，校验人员的方法',
      setter: 'FunctionSetter'
    },
    // 绑定地图方法
    bindMap: {
      type: Function,
      default: () => {},
      desc: '绑定地图方法',
      setter: 'FunctionSetter'
    },
    isQueCreateHidden: {
      type: Number,
      default: 0,
      desc: '是否人才发展专业版已到期，隐藏问卷创建按钮',
      setter: 'TabSetter',
      enums: [{
        label: '否',
        value: 0
      }, {
        label: '是',
        value: 1
      }]
    },
    projectId: {
      type: String,
      default: '',
      desc: '导入评估关系，测评导入成功会回调',
      setter: 'StringSetter'
    },
    // 前测的 id
    beforeId: {
      type: String,
      default: '',
      desc: '创建后测时的前测id',
      setter: 'StringSetter'
    }
  },
  computed: {
    stepsData() {
      if (this.isMultigang) {
        this.type = 1; // 默认为行为评估
        return ['info', 'add', 'publish'];
      }
      if (this.parentId) {
        return ['info', 'add', 'publish'];
      }
      if (this.hasAddPerson) {
        return ['select', 'info', 'add', 'publish'];
      }
      return ['select', 'info', 'publish'];
    }
  },
  data() {
    return {
      SOURCE_TYPE,
      step: this.defaultStep,
      drawerVisible: false,
      peerAssess: false,
      evalId: this.id,
      surveyId: '',
      selectScene: this.scene,
      type: +this.eType, // 1：行为评估，2：问卷评估
      owners: window.localStorage.getItem('userId') ? [{fullname: window.localStorage.getItem('fullname'), id: window.localStorage.getItem('userId'), name: window.localStorage.getItem('username'), type: 'person'}] : [],
      isAfterTest: false // 是否id对应的是后测
    };
  },
  watch: {
    visible: {
      immediate: true,
      handler(val) {
        this.drawerVisible = val;
      }
    },
    drawerVisible(val) {
      this.$emit('update:visible', val);
    },
    evalId(val) {
      this.$emit('update:id', val);
    }
  },
  methods: {
    // 下一步
    next() {
      this.step++;
      if (this.stepsData[this.step - 1] === 'info') {
        // surveyId 等响应式传递，从【子1】->【父】->【子2】 经过了两个任务周期，这边必须等待值成功传递给【子2】
        this.$nextTick(() => {
          this.$refs && this.$refs.info && this.$refs.info.reset();
        });
      }
    },
    // 上一步
    prev() {
      this.$confirm(this.$t('pc_gwnl_eval_wantToContinue'), this.$t('pc_gwnl_eval_sureToLeave'), {
        confirmButtonText: this.$t('pc_gwnl_eval_continue'),
        cancelButtonText: this.$t('pc_gwnl_global_msg_cancel'),
        type: 'warning'
      }).then(() => {
        this.step--;
      }).catch(() => { });
    },
    // 切换是否支持显示评估设置
    changeAssess(type) {
      if (type) {
        this.type = type;
      }
    },

    publish() {
      this.drawerVisible = false;
      this.$emit('publish');
    },
    save() {
      this.drawerVisible = false;
      this.$emit('save');
    }
  }
};
</script>

<style lang="scss">
.pr0 {
  .yxt-drawer__body {
    padding-right: 0 !important;
  }
}
</style>
